import React from 'react';

const HoursTabContext = React.createContext();

export default HoursTabContext;
